import { FC, RefObject } from 'react';
import styled from '@emotion/styled';
import { Gradient } from '__components/Kizen/ScrollFadeContainer';
import useEndsOfScroll from 'hooks/useEndsOfScroll';

// The scroller's parent must be position: relative
const Anchor = styled.div<{ $edge: 'top' | 'bottom' | 'left' | 'right' }>`
  position: absolute;
  pointer-events: none;
  z-index: 2;
  ${({ $edge }) =>
    $edge === 'top' || $edge === 'bottom'
      ? `${$edge}: 0; left: 0; right: 0;`
      : `${$edge}: 0; top: 0; bottom: 0;`}
`;

const FADE_LENGTH = 20;
const SIDE_STYLE = { height: '100%' };

export interface ScrollFadesProps {
  scrollRef: RefObject<HTMLElement>;
  deps: unknown[];
  horizontal?: boolean;
  color?: string;
}

export const ScrollFades: FC<ScrollFadesProps> = ({
  scrollRef,
  deps,
  horizontal = false,
  color = 'var(--color-background-white)',
}) => {
  // [atTop, atRight, atBottom, atLeft]
  const [atTop, atRight, atBottom, atLeft] = useEndsOfScroll(scrollRef, deps);
  const edges = horizontal
    ? ([
        ['top', atTop],
        ['bottom', atBottom],
        ['left', atLeft],
        ['right', atRight],
      ] as const)
    : ([
        ['top', atTop],
        ['bottom', atBottom],
      ] as const);
  return (
    <>
      {edges.map(([edge, atEnd]) => (
        <Anchor key={edge} $edge={edge} aria-hidden>
          <Gradient
            position={edge}
            fadeIn={!atEnd}
            fadeStart={0}
            fadeLength={FADE_LENGTH}
            color={color}
            zIndex={2}
            style={edge === 'left' || edge === 'right' ? SIDE_STYLE : undefined}
          />
        </Anchor>
      ))}
    </>
  );
};
